export default __webpack_public_path__ + "media/images/flags/va-20249df9b82002fff498173f022f1a5f.png";